import React from 'react'
import { useState, useEffect } from 'react';
import { get_data_of_exercise } from '../../js functions/LDBfunctions';
import Counter from './master/counter.js';
import Line_chart from './master/Line_chart.js';

export default function WorkoutDuration({ dateRangeStart, dateRangeEnd, ActiveExcercise }) {
    const [WorkoutDurationData, setWorkoutDurationData] = useState([]);
    const Yaxis_name = "Workout Duration (minutes)";
    const [slope, setSlope] = useState();
    const heading = "New Workout Duration";



    useEffect(() => {

        calculateWorkoutDuration(dateRangeStart, dateRangeEnd, ActiveExcercise);

    }, [dateRangeStart, dateRangeEnd, ActiveExcercise]);


    // Function to calculate total workout duration
    async function calculateWorkoutDuration(dateRangeStart, dateRangeEnd, ActiveExcercise) {


        try {

            const data = await get_data_of_exercise(dateRangeStart, dateRangeEnd, ActiveExcercise);

            if (!data || data.length === 0) {
                console.log(` Workout Duration : No data available for ${ActiveExcercise} in the given date range`);
                setWorkoutDurationData([]);
            } else {




                const durationData = data.map(workout => {
                    const startTime = new Date(workout.start_time);
                    const endTime = new Date(workout.end_time);

                    // Calculate duration in minutes
                    const durationInMinutes = Math.round((endTime - startTime) / (1000 * 60));

                    // Format date for x-axis
                    const date = startTime.toLocaleDateString();

                    return {
                        x: date,
                        y: durationInMinutes
                    };
                });

                setWorkoutDurationData(durationData);

            }

        } catch (error) {
            console.log(error)
        }


    };



    return (
        <div className='chart-card-container'>
            <h4>{heading}</h4>


            <div className='summary-box' >



                <div className='counter-box' >

                    <Counter counterData={slope} heading={"Slope"} />

                </div>



            </div>

            <div>




                {WorkoutDurationData.length === 0 ? (
                    <div>
                        {console.log(`No data available for ${ActiveExcercise} in the given date range`)}
                        <p>No data available for {ActiveExcercise} in the given date range</p>
                    </div>
                ) : (
                    <div>

                        <Line_chart data={WorkoutDurationData} Yaxis_name={Yaxis_name} />

                    </div>
                )}

            </div>
        </div>
    );
}
